import React from "react";

type Props = {};

export const Footer = React.memo((props: Props) => {
  return <></>;
});

export default Footer;
